/** Full navigation to Worker OAuth routes (avoids broken <form>+display:contents in some browsers). */
export function startGoogleOAuth() {
  window.location.assign(`${window.location.origin}/api/auth/oauth/google`);
}

export function startAppleOAuth() {
  window.location.assign(`${window.location.origin}/api/auth/oauth/apple`);
}
